var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC69\\u200D\\uD83C\\uDF93-Students-management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Platform-Admin-/-Dashboard-/-Manage-Students-/-Total-Count",
    transform: "translate(-796, -178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stats",
    transform: "translate(96, 152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PN",
    transform: "translate(676, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24, 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Copy-4",
    transform: "translate(0, 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    fill: "#09643C",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/User-Plus/Filled",
    transform: "translate(12, 10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 27,
    height: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.25625,11.6015625 L22.78125,11.6015625 L22.78125,9.0703125 C22.78125,8.72226563 22.5028125,8.4375 22.1625,8.4375 L20.925,8.4375 C20.5846875,8.4375 20.30625,8.72226563 20.30625,9.0703125 L20.30625,11.6015625 L17.83125,11.6015625 C17.4909375,11.6015625 17.2125,11.8863281 17.2125,12.234375 L17.2125,13.5 C17.2125,13.8480469 17.4909375,14.1328125 17.83125,14.1328125 L20.30625,14.1328125 L20.30625,16.6640625 C20.30625,17.0121094 20.5846875,17.296875 20.925,17.296875 L22.1625,17.296875 C22.5028125,17.296875 22.78125,17.0121094 22.78125,16.6640625 L22.78125,14.1328125 L25.25625,14.1328125 C25.5965625,14.1328125 25.875,13.8480469 25.875,13.5 L25.875,12.234375 C25.875,11.8863281 25.5965625,11.6015625 25.25625,11.6015625 Z M9.7875,13.5 C12.5216016,13.5 14.7375,11.2337402 14.7375,8.4375 C14.7375,5.64125977 12.5216016,3.375 9.7875,3.375 C7.05339844,3.375 4.8375,5.64125977 4.8375,8.4375 C4.8375,11.2337402 7.05339844,13.5 9.7875,13.5 Z M13.2525,14.765625 L12.6066797,14.765625 C11.7481641,15.169043 10.7929688,15.3984375 9.7875,15.3984375 C8.78203125,15.3984375 7.83070313,15.169043 6.96832031,14.765625 L6.3225,14.765625 C3.45304688,14.765625 1.125,17.146582 1.125,20.08125 L1.125,21.7265625 C1.125,22.7746582 1.95644531,23.625 2.98125,23.625 L16.59375,23.625 C17.6185547,23.625 18.45,22.7746582 18.45,21.7265625 L18.45,20.08125 C18.45,17.146582 16.1219531,14.765625 13.2525,14.765625 Z",
    id: "Icon",
    fill: "#23B34A"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddUser);
export default __webpack_public_path__ + "static/media/icon-add-user.2c9a9249.svg";
export { ForwardRef as ReactComponent };